import React, { Component } from "react";
import NotesView from "./NotesView";
import MetadataView from "./MetadataView";
import BibliographyView from "./BibliographyView";

export default class ItemDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: true,
      css: "changesbold",
      isChecked: true,
    };
  }

  showTheTing = (itemid) => {
    window.open(
      "/just/" + itemid,
      "_blank",
      "status=no, menubar=no, width=800,height=800"
    );
  };

  changeStyle(event) {
    const css = event.target.checked ? "changesbold" : "changesnormal";
    this.setState({ css: css, isChecked: event.target.checked });
    //document.body.classList.toggle('darkClass', this.props.isDark)
  }

  render() {
    if (this.state.dataLoaded) {
      return (
        <div>
          <div className="well">
            {this.props.count ? (
              <div className="col-md-6 col-md-offset-6">
                <span className="badge">
                  {this.props.index} of {this.props.count}
                </span>
              </div>
            ) : (
              ""
            )}

            <div className="col-md-1 col-sm-1"> {this.props.prev}</div>
            <div className="col-md-10 col-sm-10">
              <div className="col-md-12">
                <div className="col-md-6">
                  <h3
                    style={{ float: "left" }}
                    className={this.state.css}
                    dangerouslySetInnerHTML={{
                      __html: this.props.item.item.richheading,
                    }}
                  ></h3>
                </div>
                <div
                  className="col-md-6 urlimage"
                  dangerouslySetInnerHTML={{
                    __html: this.props.item.item.image,
                  }}
                ></div>
              </div>
            </div>
            <div className="col-md-1 col-sm-1">{this.props.next}</div>

            <div className="row">
              <div className="col-md-12 col-sm-12">
                <input
                  type="checkbox"
                  onChange={this.changeStyle.bind(this)}
                  checked={this.state.isChecked}
                />{" "}
                Highlight changes in latest edition
                {this.props.item.item.richcontent ? (
                  <pre
                    style={{ padding: 50 }}
                    className={this.state.css}
                    dangerouslySetInnerHTML={{
                      __html: this.props.item.item.richcontent,
                    }}
                  ></pre>
                ) : (
                  <pre style={{ padding: 50 }}>
                    No text or not available yet. See Notes below
                  </pre>
                )}
              </div>

              <div className="row">
                <div className="col-md-12 col-sm-12">
                  {!this.props.newwindow ? (
                    <div className="container">
                      <a
                        style={{ cursor: "pointer" }}
                        className="pull-right"
                        onClick={() =>
                          this.showTheTing(this.props.item.item.id)
                        }
                      >
                        <span
                          className="glyphicon glyphicon-new-window preview"
                          aria-hidden="true"
                        ></span>
                        {` Open in new window`}
                      </a>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <div className="well">
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <NotesView
                  legend={this.props.item.legends.notes}
                  data={this.props.item.item.notes}
                />
              </div>
            </div>
          </div>

          <div className="well">
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div className="col-md-6 col-sm-12">
                  <div
                    style={{
                      backgroundColor: "white",
                      padding: 20,
                      margin: 10,
                    }}
                  >
                    <h4>Metadata</h4>
                    <MetadataView data={this.props.item.meta} />
                  </div>
                </div>
                <div className="col-md-6 col-sm-12">
                  <BibliographyView
                    reference={this.props.item.legends.reference}
                    data={this.props.item.bibliography}
                  />
                </div>
              </div>
            </div>
          </div>

          {/*
  <div className="col-md-6 col-sm-12">
    {this.props.item.item.image?
        <img alt="some text" className="img-responsive" src={this.props.item.item.image} />
        :
        <div><h1 className="img-responsive"><span className="glyphicon glyphicon-picture">
        </span></h1><div><br /><h2>no image available yet</h2></div>
      </div>

      }
      </div>
      */}
        </div>
      );
    } else {
      return (
        <div className="wellstyle">
          <div>Loading&#8230;</div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/itemscreens/ItemDetail.js